import ProspectiveDataTab from "../ProspectiveDataTab/ProspectiveDataTab"
import ProjectDataTab from "../ProjectDataTab/ProjectDataTab"
import ClientDataTab from "../ClientDataTab/ClientDataTab"
import ScratchpadTab from "../ScratchpadTab/ScratchpadTab"

var is_project = {
    components: {
        ProspectiveDataTab,
        ProjectDataTab,
        ClientDataTab,
        ScratchpadTab
    },
    props: {
        record: {
            required: true
        }
    },
    data () {
        return {
            entity: "project"
        }
    }
}

export default is_project
